(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-icd-10', {
            parent: 'entity',
            url: '/covid-icd-10',
            data: {
                authorities: [],
                pageTitle: 'CovidIcd10S'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-icd-10/covid-icd-10-s.html',
                    controller: 'CovidIcd10Controller',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access);
                }]
            }
        })
        .state('covid-icd-10.new', {
            parent: 'covid-icd-10',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-icd-10/covid-icd-10-dialog.html',
                        controller: 'CovidIcd10DialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    icd10: null,
                                    facility: CoreService.getCurrentFacility()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('covid-icd-10', null, {reload: 'covid-icd-10'});
                    }, function () {
                        $state.go('covid-icd-10');
                    });
                }
            }]
        })
        .state('covid-icd-10.edit', {
            parent: 'covid-icd-10',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
              if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access)) {
                  $uibModal.open({
                      templateUrl: 'app/entities/covid-icd-10/covid-icd-10-dialog.html',
                      controller: 'CovidIcd10DialogController',
                      controllerAs: 'vm',
                      backdrop: 'static',
                      windowTopClass: 'custom-dialog-styles',
                      size: 'lg',
                      resolve: {
                          entity: ['CovidIcd10', function (CovidIcd10) {
                              return CovidIcd10.get({id: $stateParams.id}).$promise;
                          }]
                      }
                  }).result.then(function () {
                      $state.go('covid-icd-10', null, {reload: 'covid-icd-10'});
                  }, function () {
                      $state.go('^');
                  });
              }
            }]
        })
        .state('covid-icd-10.delete', {
            parent: 'covid-icd-10',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
              if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access)) {
                  $uibModal.open({
                      templateUrl: 'app/entities/covid-icd-10/covid-icd-10-delete-dialog.html',
                      controller: 'CovidIcd10DeleteController',
                      controllerAs: 'vm',
                      windowTopClass: 'custom-dialog-styles',
                      size: 'md',
                      resolve: {
                          entity: ['CovidIcd10', function (CovidIcd10) {
                              return CovidIcd10.get({id: $stateParams.id}).$promise;
                          }]
                      }
                  }).result.then(function () {
                      $state.go('covid-icd-10', null, {reload: 'covid-icd-10'});
                  }, function () {
                      $state.go('^');
                  });
              }
            }]
        });
    }

})();
